import { put, call, select } from 'redux-saga/effects';
import Api, { doLogout, logoutAction } from 'domain/api';
// selectors
import * as Router from 'domain/router';
// actions
import * as action from './actions';
// adapters
import { categoriesStoreAdapter } from './adapters';
// types

// eslint-disable-next-line max-len
export function* getCategoriesWorkerParams(params) {
  // eslint-disable-next-line max-len
  function* prepare(prepareParams = {}) {
    return {
      isConfidential: prepareParams.companyType === 'confidential',
      category: prepareParams.category,
      ...(yield select(Router.querySelector)),
    };
  }

  return {
    apiName: 'getCategories',
    config: {
      params: yield call(prepare, params),
    },
    prepare,
    success(data) {
      return {
        type: action.getCategoriesAction.success,
        payload: categoriesStoreAdapter(data),
      };
    },
    // $FlowFixMe
    failure(err) {
      // eslint-disable-next-line no-console
      console.log('categories worker error', err);
      // return doLogout(action.getCategoriesAction, err);
      return logoutAction(action.getCategoriesAction, err);
    },
  };
}

export function* ensureGetCategories(params) {
  yield put({
    type: action.getCategoriesAction.request,
  });
  // if we yield different data from generator (2 yields) it cant be
  // correctly typed with Generator<Effect, void, yield1Type | yield2Type>
  // so ignoring type for the first yield
  // $FlowFixMe
  const { apiName, config } = yield call(getCategoriesWorkerParams, params);
  try {
    const { data } = yield call(Api[apiName], config);
    yield put({
      type: action.getCategoriesAction.success,
      payload: categoriesStoreAdapter(data),
    });
  } catch (err) {
    yield doLogout(action.getCategoriesAction, err);
  }
}
